import React, { useEffect, useRef } from "react";
import { Grid, InputLabel, OutlinedInput } from "@mui/material";
import { useCadastrosBasicoDispatch, useCadastrosBasicoState } from "../context/cadastros-basico-context";
import { useCadastrosBasicoController } from "../context/cadastros-basico-controller";
import { FORM_TYPES } from "../context/cadastros-basico-reducer";
export const CategoriaNoticiasForm = () => {
    const { dataRequest } = useCadastrosBasicoState();
    const { handleOnChangeForm } = useCadastrosBasicoController();
    const firstInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, []);
    
    return (
        <React.Fragment>
            <Grid container spacing={2}>
                <Grid
                    item
                    lg={12}
                    sm={12}
                    xl={12}
                >
                    <InputLabel>Nome</InputLabel>
                    <OutlinedInput
                        ref={firstInputRef}
                        size="small"
                        inputProps={{ min: 0 }}
                        error={dataRequest?.name === undefined || dataRequest?.name.length === 0 ? true : false}
                        name="input-name"
                        value={dataRequest?.name}
                        defaultValue={dataRequest?.name}
                        onChange={(e) => handleOnChangeForm(FORM_TYPES.categoriesNews, e)}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}